<template>
<div>
    <h3 class="mt-3">{{index + 1}} - {{question.translation.name}}</h3>
    <template v-if="question.answer">
        <badge v-if="exerciseWaiting" class="mb-2" type="info">
            <i class="white mdi mdi-clock-outline"/>
            <span class="white">{{$t('lesson.exercise_waiting')}}</span>
        </badge>
        <badge v-else-if="!question.approve" class="mb-2" type="success">
            <i class="white mdi mdi-check-all"/>
            <span class="white">{{$t('lesson.exercise_revised')}}</span>
        </badge>
        <template v-else>
            <badge v-if="question.answer.approve_question" class="mb-2" type="success">
                <i class="white mdi mdi-check-all"/>
                <span class="white">{{$t('lesson.approved')}}</span>
            </badge>
            <badge v-else class="mb-2" type="danger">
                <i class="white mdi mdi-check-all"/>
                <span class="white">{{$t('lesson.reproved')}}</span>
            </badge>
        </template>
        <div v-if="question.answer.justify_obs">
            <h4>{{$t('lesson.obs')}}</h4>
            <p class="text-muted">
                <i class="justify" v-html="question.answer.justify_obs"/>
            </p>
            <div class="d-flex justify-content-end">
                <h4>
                    {{$t('lesson.revised_by')}}
                    <span class="text-muted ml-1">
                        {{question.answer.justified_by}}
                    </span>
                </h4>
            </div>
        </div>
        <div v-if="this.question.answer.correction_date">
            <h4 class="d-flex justify-content-end">
                {{$t('lesson.corrected_on')}}:
                <span class="text-muted ml-1">
                    {{ formatDate(this.question.answer.correction_date) }}
                </span>
            </h4>
        </div>
    </template>
    <span
        v-if="question.translation.description"
        v-html="question.translation.description"
        class="mb-3 d-block"
    />
    <p
        v-if="question.translation.observation"
        class="mb-3 d-block"
        style="font-style: italic"
    >
        {{question.translation.observation}}
    </p>
    <editor
        v-if="!isFinished"
        v-model="answer"
        :name="$t('lesson.answer_placeholder')"
        :error="errors.first($t('lesson.answer_placeholder'))"
        class="nch--html-editor"
        v-validate="'required'"
    />
    <p v-else class="answer" v-html="answer"/>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import debounce from '../../../../helpers/helpers';
import Badge from '../../../../argon/components/Badge';
import Editor from '../../../../argon/components/Inputs/HtmlEditor';

import formatDate from '../../../../mixins/FormatDate';

export default {
    name: 'ClassExerciseDissertation',
    mixins: [formatDate],
    data() {
        return {
            answer: '',
            model: '',
            firstLoad: false,
        };
    },
    components: {
        Badge,
        Editor,
    },
    props: {
        isFinished: Boolean,
        question: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    watch: {
        answer: debounce(function unnamed() {
            if (!this.isFinished) {
                this.submitAnswer();
            }
        }, 500),

        question(newVal) {
            if (!newVal.answer && !this.isFinished && this.answer) {
                this.submitAnswer();
            }
        },
    },
    methods: {
        async submitAnswer() {
            var response = await this.$store.dispatch('CLASS_EXERCISE_SUBMIT_OPTION', {
                questionId: this.question.id,
                answer: this.answer
            });

            if (!response) {
                this.model = '';
                this.answer = '';
                this.$notify({
                    type: 'danger',
                    message: this.$t('content.exercise.error.no_connection'),
                });
            }
        }
    },
    computed: {
        ...mapGetters({
            exercise: 'CLASS_EXERCISE',
            color: 'COLOR',
        }),

        exerciseWaiting() {
            const sameAnswer = this.question.answer === this.answer;
            return (sameAnswer || (this.question.answer && this.question.answer.grade === null));
        },
    },

    mounted() {
        const answer = this.question.answer ? this.question.answer.text : null;
        if (answer) this.answer = answer;
        this.firstLoad = true;
    },
};
</script>

<style lang="sass">
.white
    color: #FFF
</style>
<style>
    .answer p > img,
    .justify p > img {
        width: 100%;
    }
    .answer {
        padding: 10px;
        max-height: 200px;
        overflow: auto;
        background-color: #f4f5f7;
    }
</style>
